import AddressesTable from './AddressesTable'

export default AddressesTable
